import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

const faqs: FaqItem[] = [
  {
    q: '快看影视是否需要注册或付费？',
    a: '完全不需要！快看影视坚持免费电影在线观看的原则，所有影片均可直接播放，无需注册账号、无需支付任何费用，打开网站即可畅享高清电影。',
  },
  {
    q: '电影加载慢或卡顿怎么办？',
    a: '快看影视采用多线智能加速和全球CDN分发技术，正常情况下电影秒播不缓冲。如遇卡顿，建议检查网络连接或尝试切换播放线路，大部分情况都能解决。',
  },
  {
    q: '最新电影多久能上线？',
    a: '我们的内容团队每日持续更新电影大全片库，国内外最新电影通常在公映后极短时间内即可上线。关注首页"新片速递"专题，第一时间获取最新片源推送。',
  },
  {
    q: '支持哪些设备观看？',
    a: '快看影视全面适配手机、平板、笔记本电脑和台式机等所有主流设备。只要有浏览器和网络连接，随时随地都能免费高清看电影，无需下载任何APP。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              关于快看影视，你可能想知道的一切
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                    {faq.q}
                  </h3>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                      openIndex === i ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === i ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}